import React, { useState } from "react";
import { RoomsType } from "@/types";
import RoomModal from "@/components/RoomModal"; // Adjust the path as necessary
import { useTranslation } from "react-i18next";
import Placeholder from "@/pages/Search/PlaceHolderSearch";

type RoomItemType = {
    room: RoomsType;
};

const RoomItem: React.FC<RoomItemType> = ({ room }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const { t } = useTranslation(["common", "validation", "glossary"]);

    return (
        <div className="md:max-w-md xl:max-w-none md:mx-auto p-4">
            <div className="xl:flex-row flex flex-col items-start xl:items-center justify-between border-2 border-primary rounded-xl xl:p-4 p-2 mb-4">
                <div className="flex xl:flex-row flex-col items-start xl:items-center">
                    <div className="xl:h-16 xl:w-16 md:w-full rounded-lg overflow-hidden">
                        <img
                            src={room.image}
                            alt="Room"
                            className="object-cover h-full w-full"
                        />
                    </div>

                    <div className="xl:ml-4 md:ml-0">
                        <h3 className="xl:text-lg mt-2 xl:mt-0 mb-4 xl:mb-0 text-xl font-semibold">
                            {room.name}
                        </h3>
                    </div>
                </div>
                <div className="mb-4 xl:mb-0">
                    <div>
                        {`${room.max_adults} ${t("adults", { ns: "glossary" })}${room.max_children !== null ? ` + ${room.max_children} ${t("childs", { ns: "glossary" })}` : ""}`}
                    </div>
                </div>
                <div className="flex flex-wrap mb-4 xl:mb-0 items-center">
                    {room.amenities && room.amenities.length > 0 ? (
                        room.amenities.map((amenity, index) => (
                            <span
                                key={index}
                                className="text-primary mr-2 rounded"
                                dangerouslySetInnerHTML={{
                                    __html: amenity.icon,
                                }}
                            />
                        ))
                    ) : (
                        <span></span>
                    )}
                </div>
                <button
                    title={t("view_room", { ns: "glossary" })}
                    className="bg-[#1D26CA] w-full xl:w-auto text-white px-4 py-2 rounded-lg"
                    onClick={openModal}
                >
                    {t("view_room", { ns: "glossary" })}
                </button>
            </div>
            <RoomModal room={room} isOpen={isModalOpen} onClose={closeModal} />
        </div>
    );
};

export default RoomItem;
